import { combineReducers, Reducer } from 'redux'
import { connectRouter } from 'connected-react-router'
import productsSearchRdc from '../ProductsSearch/reducers/ProductsSearchRdc'
import authRdc from '../Auth/reducers/AuthRdc'
import orderSheetsRdc from '../Home/reducers/OrderSheetsRdc'
import orderRdc from '../Quote/reducers/OrderRdc'
import layoutRdc from '../Layout/reducers/LayoutRdc'
import supplierRdc from '../Supplier/reducers/SupplierRdc'
import supplierPaymentRdc from '../SupplierPayment/supplierPaymentSlice'
import accountDetailsRdc from '../AccountDetails/accountDetailsSlice'
import adminRdc from '../Admin/adminSlice'

import { RootState, RootAction } from 'typesafe-actions';
import storage from 'redux-persist/lib/storage'


const appReducer = (history: any) => combineReducers({
    router: connectRouter(history),
    productsSearchRdc,
    authRdc,
    adminRdc,
    orderSheetsRdc,
    orderRdc: orderRdc,
    layoutRdc,
    supplierRdc,
    supplierPaymentRdc,
    accountDetailsRdc
});

export const rootReducer = (history: any): Reducer<RootState, RootAction> => {//use root reducer to reset the whole
    return (state: RootState | undefined, action: RootAction): RootState => {
        if (action.type === 'LOGIN_SUCCESS' || action.type === 'LOGOUT_SUCCESS') {
            state = undefined
            storage.removeItem('persist:root')
        }

        return appReducer(history)(state, action)
    }
}

export default appReducer;